import script from "./MergedUserMemberList.vue?vue&type=script&setup=true&lang=js"
export * from "./MergedUserMemberList.vue?vue&type=script&setup=true&lang=js"

import "./MergedUserMemberList.vue?vue&type=style&index=0&id=2501d91c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2501d91c"]])

export default __exports__